import profile from "@/profiles/profileSingleton"

import {
  TRIMBLE_DEVELOPER_MACHINE_NAME,
  TRIMBLE_DEVELOPER_NEWS_CENTER_TAG,
  TRIMBLE_DEVELOPER_NEWS_LANDING_SLUG,
  TRIMBLE_DEVELOPER_NEWS_URL_PREFIX,
} from "./trimbleDeveloperNewsConstants"

export {
  TRIMBLE_DEVELOPER_NEWS_CENTER_TAG,
  TRIMBLE_DEVELOPER_NEWS_BLOG_SLUG,
  TRIMBLE_DEVELOPER_NEWS_LANDING_SLUG,
  TRIMBLE_DEVELOPER_NEWS_URL_PREFIX,
} from "./trimbleDeveloperNewsConstants"

export {
  getTrimbleDeveloperNewsRewritesForNextConfig,
  getTrimbleDeveloperNewsRewriteDestination,
} from "./trimbleDeveloperNewsRewrites"

export function isTrimbleDeveloperSite(): boolean {
  const envSite = process.env.NEXT_PUBLIC_SITE_MACHINE_NAME
  const envProfile = process.env.NEXT_PUBLIC_PROFILE

  if (envSite === TRIMBLE_DEVELOPER_MACHINE_NAME) return true
  if (envProfile?.startsWith("trimble-developer")) return true
  if (envSite && envSite !== TRIMBLE_DEVELOPER_MACHINE_NAME) return false

  return (
    profile.NEXT_PUBLIC_SITE_MACHINE_NAME === TRIMBLE_DEVELOPER_MACHINE_NAME ||
    profile.NEXT_PUBLIC_PROFILE?.startsWith("trimble-developer") === true
  )
}

export function entryHasTrimbleDeveloperNewsCenterTag(entry: {
  contentfulMetadata?: { tags?: { id?: string | null }[] | null } | null
}): boolean {
  const tags = entry?.contentfulMetadata?.tags ?? []
  return tags.some(tag => tag?.id === TRIMBLE_DEVELOPER_NEWS_CENTER_TAG)
}

export function usesTrimbleDeveloperNewsUrls(): boolean {
  return isTrimbleDeveloperSite()
}

/** Map public `/news` URL segments to the Contentful landing-page slug. */
export function mapTrimbleDeveloperNewsUrlSlugToContentful(
  urlSlug: string,
): string {
  if (!usesTrimbleDeveloperNewsUrls()) return urlSlug
  if (urlSlug === TRIMBLE_DEVELOPER_NEWS_URL_PREFIX) {
    return TRIMBLE_DEVELOPER_NEWS_LANDING_SLUG
  }
  return urlSlug
}

/** Map the Contentful landing-page slug back to the public `/news` URL. */
export function mapTrimbleDeveloperNewsContentfulSlugToUrl(
  contentfulSlug: string,
): string {
  if (!usesTrimbleDeveloperNewsUrls()) return contentfulSlug
  if (contentfulSlug === TRIMBLE_DEVELOPER_NEWS_LANDING_SLUG) {
    return TRIMBLE_DEVELOPER_NEWS_URL_PREFIX
  }
  return contentfulSlug
}

export function isTrimbleDeveloperNewsContentPrefix(
  prefix: string | undefined,
): boolean {
  return prefix === TRIMBLE_DEVELOPER_NEWS_URL_PREFIX
}

export function buildTrimbleDeveloperNewsArticleUrl(
  lang: string,
  slug: string,
): string {
  return `/${lang}/${TRIMBLE_DEVELOPER_NEWS_URL_PREFIX}/${slug}`
}
